import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Row, Col, Form, Space, Input, Spin, AutoComplete, Select } from "antd";
import {
  MinusSquareFilled,
  PlusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import PropTypes from "prop-types";
import { getRequest, patchRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import ButtonField from "../../common/htmlComponents/ButtonField";
const { Option } = Select;
const SupplierBillingDetails = ({
  VendorId,
  supplierBillingId,
  SetSupplierBillingId,
  gstVendorId,
  gstValue,
  CompanyId,
  setShowBankDetailsCollapse,
  setShowbank,
}) => {
  const formRef = useRef();
  const { t } = useTranslation();
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const initialState = {
    suppliers_billing_details: [
      {
        company: CompanyId,
        category_tree: 1,

        address_line_1: null,
        address_line_2: null,
        gst_for_billing: null,
        person_name: null,
        landmark: null,
        mobile_number: null,
        email: null,
        pincode: null,
        pincode_number: "",
        city: null,
        state: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  const [pincodeListBilling, setPincodeListBilling] = useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");

  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor-suppliers-billing-details/?vendor=${VendorId}&company=${CompanyId}`
        );
        if (apiResponse.data.success) {
          setState({
            suppliers_billing_details: apiResponse.data.data.map(
              (bankDetail) => {
                const {
                  vendor,
                  company,
                  company_name,
                  pincode_number,
                  vendor_name,
                  ...rest
                } = bankDetail;
                return {
                  ...rest,
                  company: company || CompanyId || null,
                };
              }
            ),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const {
                id,
                vendor,
                company,
                company_name,
                vendor_name,
                ...rest
              } = bankDetail;
              return rest;
            }
          );

          setWeightSizeInquiryFieldValueSuppliers(modifiedBankDetails);

          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    const getGstVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor-suppliers-billing-details/suppliers-billing-details-by-gst/?gst_no=${gstValue}`
        );
        if (apiResponse.data.success) {
          setState({
            suppliers_billing_details: apiResponse.data.data.map(
              (bankDetail) => {
                const { vendor, ...rest } = bankDetail;
                return rest;
              }
            ),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const { id, vendor, ...rest } = bankDetail;
              return rest;
            }
          );

          setWeightSizeInquiryFieldValueSuppliers(modifiedBankDetails);
          SetSupplierBillingId(apiResponse?.data?.data[0]?.id);
          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else if (apiResponse.data.success === false) {
          setState({
            suppliers_billing_details: apiResponse.data.data.map(
              (bankDetail) => {
                const { id, vendor, ...rest } = bankDetail;
                return rest;
              }
            ),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const { id, vendor, ...rest } = bankDetail;
              return rest;
            }
          );

          setWeightSizeInquiryFieldValueSuppliers(modifiedBankDetails);
          SetSupplierBillingId(null);
          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    if (VendorId !== null && gstVendorId === null) {
      getVendorOnboarding();
    }
    if (gstVendorId !== null) {
      getGstVendorOnboarding();
    }
  }, [VendorId]);

  const setWeightSizeInquiryFieldValueSuppliers = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["category_tree" + objectKey] = objectValue.category_tree;
      fieldObject["gst_for_billing" + objectKey] = objectValue.gst_for_billing;
      fieldObject["address_line_1" + objectKey] = objectValue.address_line_1;
      fieldObject["address_line_2" + objectKey] = objectValue.address_line_2;
      fieldObject["person_name" + objectKey] = objectValue.person_name;
      fieldObject["landmark" + objectKey] = objectValue.landmark;
      fieldObject["email" + objectKey] = objectValue.email;
      fieldObject["state" + objectKey] = objectValue.state;
      fieldObject["city" + objectKey] = objectValue.city;
      fieldObject["pincode" + objectKey] = objectValue.pincode_number;
      fieldObject["mobile_number" + objectKey] = String(
        objectValue.mobile_number || "+91"
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };
  const addInquirySuppliers = () => {
    let newBankArr = [
      ...state.suppliers_billing_details,
      {
        company: CompanyId,
        category_tree: 1,
        gst_for_billing: null,
        address_line_1: null,
        address_line_2: null,
        pincode_number: "",
        person_name: null,
        landmark: null,
        mobile_number: null,
        email: null,
        pincode: null,
        city: null,
        state: null,
      },
    ];
    setState({ ...state, suppliers_billing_details: newBankArr });
    setPincodeListBilling([]);
    setWeightSizeInquiryFieldValueSuppliers(newBankArr);
  };

  const removeInquirySuppliers = async (lastIndex) => {
    let filterBankArr = state.suppliers_billing_details.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, suppliers_billing_details: filterBankArr });
    setWeightSizeInquiryFieldValueSuppliers(filterBankArr);
  };

  const handleClonegstInputChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleCloneShopChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleCloneAreaChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };
  const handlePincodeListingChange = async (index, pincode, field) => {
    if (
      pincode.length > 4 &&
      pincode !== null &&
      pincode !== "" &&
      pincode !== undefined
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          let updatedAssignCity = state.suppliers_billing_details;
          updatedAssignCity[index][field] = id;
          updatedAssignCity[index]["state"] = state_name;
          updatedAssignCity[index]["city"] = city_name;
          updatedAssignCity[index]["pincode_number"] = pincode_number;
          setState({ ...state, suppliers_billing_details: updatedAssignCity });
          formRef.current.setFieldsValue({
            [`state${index}`]: state_name,
            [`city${index}`]: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      let updatedAssignCity = state.suppliers_billing_details;
      updatedAssignCity[index][field] = "";
      updatedAssignCity[index]["state"] = "";
      updatedAssignCity[index]["city"] = "";
      updatedAssignCity[index]["pincode_number"] = "";
      setState({ ...state, suppliers_billing_details: updatedAssignCity });
      formRef.current.setFieldsValue({
        [`state${index}`]: "",
        [`city${index}`]: "",
      });
    }
  };

  const searchINBilling = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBilling(apiResponse.data.results.data);
    }
  };
  const onSearchBilling = async (value) => {
    setSearchValueBilling(value);
    value.length >= 4
      ? searchINBilling(!value ? null : value)
      : setPincodeListBilling([]);
  };
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.suppliers_billing_details;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, suppliers_billing_details: newPersonArr });
  };

  const handleSubmit = async () => {
    const isInvalidRow = state.suppliers_billing_details.some(
      (bank) =>
        !bank.gst_for_billing ||
        !bank.address_line_1 ||
        !bank.address_line_2 ||
        !bank.person_name ||
        !bank.landmark ||
        !bank.mobile_number ||
        !bank.email ||
        !bank.pincode ||
        !bank.city ||
        !bank.state
    );

    if (isInvalidRow) {
      ErrorNotificationMsg(
        t("Please fill all required fields in billing details.")
      );
      return;
    }

    const billingDetailsWithCompany = state.suppliers_billing_details.map(bank => ({
      ...bank,
      company: CompanyId
    }));

    const payload = {
      suppliers_billing_details:
        billingDetailsWithCompany &&
        billingDetailsWithCompany.every(
          (bank) =>
            bank.gst_for_billing === null &&
            bank.address_line_1 === null &&
            bank.address_line_2 === null &&
            bank.person_name === null &&
            bank.landmark === null &&
            bank.mobile_number === null &&
            bank.email === null &&
            bank.pincode === null &&
            bank.city === null &&
            bank.state === null
        )
          ? []
          : billingDetailsWithCompany,
    };
    try {
      setBtnLoading(true);
      let response;
      if (supplierBillingId === null) {
        const url =
          VendorId !== null
            ? `vendor-suppliers-billing-details/${VendorId}/add-suppliers-billing-details/`
            : `vendor-suppliers-billing-details/${gstVendorId}/add-suppliers-billing-details/`;
        response = await patchRequest(url, payload);
      } else {
        const url =
          VendorId !== null
            ? `vendor-suppliers-billing-details/${VendorId}/`
            : `vendor-suppliers-billing-details/${gstVendorId}/`;

        response = await patchRequest(url, payload);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          supplierBillingId === null
            ? t("Supplier billing details added succesfully")
            : t("Supplier billing details updated succesfully")
        );
        setShowBankDetailsCollapse(true);
        setShowbank(true);
        SetSupplierBillingId(response?.data?.data[0]?.id);
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="FormBody">
        <Spin spinning={apiLoading}>
          <Form onFinish={""} autoComplete="off" ref={formRef}>
            {state.suppliers_billing_details &&
              state.suppliers_billing_details.map((x, index) => {
                return (
                  <>
                    <Row className="customcol" gutter={[16]} key={index}>
                      <Col xs={22} sm={22} md={22} xl={22} xxl={22}>
                        <Row gutter={[16]}>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6} >
                            <Form.Item
                              name={`gst_for_billing` + index}
                              label={t("Vendor GST For Billing")}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>{t("Please Enter Valid Gst")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("22AAAAA0000A1Z5")}
                                onChange={(value) =>
                                  handleClonegstInputChange(
                                    "gst_for_billing",
                                    value,
                                    index
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`address_line_1` + index}
                              label={t("Shop No., Building, Apartment")}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>{t("Please Enter Address")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("16, Block B, Ganesh Park")}
                                onChange={(value) =>
                                  handleCloneShopChange(
                                    "address_line_1",
                                    value,
                                    index
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`address_line_2` + index}
                              label={t("Area, Street")}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>
                                      {t("Please Enter Area,Street")}
                                    </Trans>
                                  ),
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("Gota")}
                                onChange={(value) =>
                                  handleCloneAreaChange(
                                    "address_line_2",
                                    value,
                                    index
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`person_name` + index}
                              label={t("pl_personName")}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>
                                      {t("Please Enter Person Name")}
                                    </Trans>
                                  ),
                                },
                                {
                                  pattern: /^[a-zA-Z_ ]+$/,
                                  message: "Please Enter Valid Name",
                                },
                                {
                                  min: 2,
                                  message: <Trans>{t("minlength_msg")}</Trans>,
                                },
                                {
                                  max: 15,
                                  message: (
                                    <Trans>{t("maxlength_personName")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("pl_personName")}
                                onChange={(value) =>
                                  handleCloneInputChange(
                                    "person_name",
                                    value,
                                    index
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`landmark` + index}
                              label={t("Landmark")}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>{t("Please Enter Landmark")}</Trans>
                                  ),
                                },
                                {
                                  min: 3,
                                  message: <Trans>{t("minlength_msg")}</Trans>,
                                },
                                {
                                  max: 30,
                                  message: (
                                    <Trans>{t("maxlength_designation")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("Gota")}
                                onChange={(value) =>
                                  handleCloneInputChange(
                                    "landmark",
                                    value,
                                    index
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`email` + index}
                              label={t("lbb_email")}
                              rules={[
                                {
                                  required: true,
                                  type: "email",
                                  message: <Trans>{t("val_email")}</Trans>,
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("pl_email")}
                                onChange={(value) =>
                                  handleCloneInputChange("email", value, index)
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`mobile_number` + index}
                              label={t("pl_ContactNo")}
                              pattern={"/^d{12}$/"}
                              rules={[
                                {
                                  required: true,
                                  message: <Trans>{t("val_phone")}</Trans>,
                                },
                                {
                                  pattern: /^\d{12}$/,
                                  message: <Trans>{t("val_phone")}</Trans>,
                                },
                              ]}
                            >
                              <PhoneInput
                                className="PhoneSection"
                                country={"in"}
                                onChange={(phone) =>
                                  handleClonePhoneInputChange(
                                    "mobile_number",
                                    phone,
                                    index
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`pincode` + index}
                              label={t("pl_pincode")}
                              prefix={<ZipCode />}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>{t("val_postal_zip_code")}</Trans>
                                  ),
                                },
                              ]}
                              onKeyPress={(e) => {
                                if (!/^\d$/.test(e.key)) {
                                  e.preventDefault(); // blocks any non-numeric key
                                }
                              }}
                            >
                              <AutoComplete
                                className="autoComplete"
                                onSearch={onSearchBilling}
                                optionFilterProp="children"
                                allowClear
                                placeholder={t("pl_pincodeselect")}
                                onChange={(value) =>
                                  handlePincodeListingChange(
                                    index,
                                    value,
                                    "pincode"
                                  )
                                }
                              >
                                {pincodeListBilling.map((option) => (
                                  <Option
                                    key={option.id}
                                    value={option.pincode_number}
                                  >
                                    {option.pincode_number}
                                  </Option>
                                ))}
                              </AutoComplete>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`city` + index}
                              label={t("pl_city")}
                              rules={[
                                {
                                  required: true,
                                  message: <Trans>{t("val_city")}</Trans>,
                                },
                              ]}
                            >
                              <Input
                                placeholder={t("place_city")}
                                value={x.city}
                                disabled
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12} md={8} xl={6} xxl={6}>
                            <Form.Item
                              name={`state` + index}
                              label={t("pl_state_province")}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <Trans>{t("val_state_province")}</Trans>
                                  ),
                                },
                              ]}
                            >
                              <Input
                                value={x.state}
                                placeholder={t("place_state")}
                                disabled
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>

                      <Col xs={24} sm={2} md={2} xl={2} xxl={2}>
                        <div className="addwrp">
                          <Space>
                            {index !== 0 ? (
                              <MinusSquareFilled
                                className="add"
                                onClick={() => removeInquirySuppliers(index)}
                              />
                            ) : (
                              ""
                            )}
                            <PlusSquareFilled
                              className="add"
                              onClick={(e) => addInquirySuppliers(e)}
                            />
                          </Space>
                        </div>
                      </Col>
                    </Row>
                  </>
                );
              })}
            {VendorId || gstVendorId ? (
              <div className="subbuttonsrow">
                <ButtonField
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={handleSubmit}
                  label={t("save")}
                  loading={btnLoading}
                />
              </div>
            ) : (
              ""
            )}
          </Form>
        </Spin>
      </div>
    </>
  );
};
SupplierBillingDetails.propTypes = {
  VendorId: PropTypes.number,
  supplierBillingId: PropTypes.number,
  SetSupplierBillingId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
  CompanyId: PropTypes.number,
  setShowBankDetailsCollapse: PropTypes.func,
  setShowbank: PropTypes.func,
};
export default SupplierBillingDetails;
